export default "__VITE_ASSET__diNzR7zP__"